(function($) {
	// if ($('#synopsis').length) {
	// 	var cert = $('#synopsis').data('cert');
	// 	//console.log( cert );
	// 	if ( cert ) {
	// 		$.ajax({
	// 			url: ESRB.counter_url,
	// 			type: 'POST',
	// 			dataType: 'json',
	// 			data: {c: cert},
	// 		})
	// 		.done(function( response ) {
	// 			//console.log( response );
	// 		});
	// 	}
	// }
})(jQuery);